import React, { useState } from 'react';
import CommonModal from '../modalLayout/CommonModal';
import Button from '../buttons/button';
import { useDeleteSurveyMutation,useDeleteSurveyPermanentMutation } from '../../../app/surveyApi/surveyApi';
import { showToast } from '../../../helpers/Utils';

const DeleteSurveyModal = ({ show, setShow, surveyId }) => {
  const [deleteSurvey, { isLoading }] = useDeleteSurveyMutation();
  const [deleteSurveyPermanent, { isLoading:isDeleting }] = useDeleteSurveyPermanentMutation();
  const [showError, setShowError] = useState("");

  const handleDelete = async () => {
    try {
      await deleteSurvey({ surveyId }).unwrap();
      showToast('Survey deleted successfully', 'success');
      setShow(false); // Close modal on success
      setShowError(''); // Clear error if any
    } catch (error) {
      setShowError(error.data?.message || 'Failed to delete survey');
    }
  };
  const handleDeletePermanently = async () => {
    try {
      await deleteSurveyPermanent({ surveyId }).unwrap();
      showToast('Survey deleted successfully', 'success');
      setShow(false); // Close modal on success
      setShowError(''); // Clear error if any
    } catch (error) {
      // Handle error message
      setShowError(error.data?.message || 'Failed to delete survey');
    }
  };

  return (
    <CommonModal show={show} setShow={setShow} title="Delete Survey" className="width-md">
      {showError ? (
        <>
          <h3 className="delete-survey text-center mb-4">{showError}</h3>
          <p className='text-center mb-3'>Do you want to delete it permanently?</p>
          <div className="d-flex gap-3 justify-content-center">
            <Button label="Cancel" className="borderedBtn" onClick={() => { setShow(false); setShowError(''); }} />
            <Button label="Delete Permanently " loading={isDeleting} onClick={handleDeletePermanently} disabled={isLoading} />
          </div>
        </>
      ) : (
        <>
          <h3 className="delete-survey text-center mb-4">Are you sure you want to delete this survey?</h3>
          <div className="d-flex gap-3 justify-content-center">
            <Button label="Cancel" className="borderedBtn" onClick={() => { setShow(false); setShowError(''); }} />
            <Button label="Confirm" loading={isLoading} onClick={handleDelete} disabled={isLoading} />
          </div>
        </>
      )}
    </CommonModal>
  );
};

export default DeleteSurveyModal;